




































































import { Component, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositInstantAccessSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositNoticeAccount) {
                ProductWizardModule.createProductViewModel.depositInstantAccessSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get fundingWindowTriggerTypeOptions() {
        return ListUtils.fundingWindowTriggerTypeOptions();
    }

}
